import { Component, input } from '@angular/core'

/**
 * A screen shown instead of a page - `/load-failed`, the not-found page - that says one thing: a heading, a sentence,
 * and the action projected under them. The heading is the page's `h1`, set in the headline role rather than the
 * global `h1`'s 5xl, so it stays on one line on a phone.
 */
@Component({
  selector: 'seiri-page-message',
  template: `
    <main class="page-message">
      <h1>{{ heading() }}</h1>
      <p>{{ text() }}</p>
      <ng-content />
    </main>
  `,
  styles: `
    .page-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--space-16);
      padding: var(--space-80) var(--space-16);
      text-align: center;
    }

    h1 {
      margin: 0;
      font: var(--mat-sys-headline-small);
      color: var(--theme-fg-heading);
    }

    p {
      margin: 0;
      font: var(--mat-sys-body-large);
      color: var(--theme-fg-muted);
    }
  `,
})
export class PageMessageComponent {
  readonly heading = input.required<string>()
  readonly text = input.required<string>()
}
